<div class="bx-global-notifications-container">
    <div class="bx-bell-icon-container">
        <div class="bx-bell-icon" (click)="showNotifications()">
            <i class="fa fa-bell"></i>
            <span *ngIf="noticeCounts" class="badge bx-notification-badge">{{ noticeCounts }}</span>
        </div>
    </div>
    <app-bx-notifications-results-panel
        [ngClass]="{ 'show-panel': showPanel }"
        [notices]="notices"
        (noticeClick)="noticeClick($event)"
        (markAsReadChange)="markAsReadChange($event)"
        (noticeClose)="noticeClose($event)"></app-bx-notifications-results-panel>
    <div class="bx-global-notifications-overlay" (click)="overlayClicked()" *ngIf="showPanel"></div>
</div>
